import { ReactNode } from 'react';
import ReactSelect, { GroupBase, OptionsOrGroups, Props as SelectProps } from 'react-select';
import Creatable, { CreatableProps } from 'react-select/creatable';

import { getWillowSelectStyles, WILLOW_SELECT_THEME } from './styles';

export type Option = { label: ReactNode | JSX.Element; value: string | number; disabled?: true };

export type Options = OptionsOrGroups<any, GroupBase<any>> | Option[];

/**
 * menuPosition: 'fixed' when inside a modal to allow the menu to spill outside
 * menuShouldBlockScroll: true when paired with menuPosition: 'fixed' to fix the menu not closing when clicking outside
 */
export type ReactSelectOverrides = Pick<SelectProps, 'menuPosition' | 'menuShouldBlockScroll'>;

export function WillowSelect<TOption = Option, TIsMulti extends boolean = false>(
  props: SelectProps<TOption, TIsMulti, GroupBase<TOption>> & { isInvalid?: boolean; compact?: boolean },
) {
  return <ReactSelect styles={getWillowSelectStyles(props)} theme={WILLOW_SELECT_THEME} {...props} />;
}

export function WillowCreatableSelect<TOption extends Option, TIsMulti extends boolean>(
  props: CreatableProps<TOption, TIsMulti, GroupBase<TOption>> & { isInvalid?: boolean; compact?: boolean },
) {
  return <Creatable styles={getWillowSelectStyles(props)} theme={WILLOW_SELECT_THEME} {...props} />;
}
